/* Chelsea and Rachel Co. 2024 */


class CnR {
    
  api_version = "2024-07";
  keyname = "subscriptions-2024-02";
  constructor(opts={}) {
      this.config = {...this.defaults(),...opts};
      this.errors=[];
      this.requires().forEach(field=>{
        if (!field in this.config) {
          this.errors.push(`Missing Required config field: ${field}`)
        }
      });
      if (this.errors.length>0) {
        throw new Error(this.errors.join("\n"));
      }
  }
  requires() {
    return []
  }
  defaults() {
    return {
      api_version:"2023-10",
      keyname:"subscriptions-2024-02"
    };
  }
  fetch(url,config) {
    if (this.config.fetch_function) {
      return pure_fetch(url,config)
    } else {
      return fetch(url,config)
    }
  }
  /* shopify cart functions */
  async getCart(url="/cart.js",extended=false,callback=()=>{}) {
      let cart = {};
      return this.fetch(url) 
    .then(res=>(extended)?res.text():res.json());
  }
  async request(url) {
      return this.fetch(url).then(text=>response.text())
  }
  async updateCart(payload) {
    return this.fetch(`/cart/update.js`, {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'xmlhttprequest'
      },
      body: JSON.stringify(payload)
    }).then((response) => response.json());
 }
  async removeItemFromCart(key) {
      return this.changeCart({
          id:key,
          quantity:0
        })
  }
  async updateItemCount(key,quantity) {
    return this.changeCart({
      id:key,
      quantity:parseInt(quantity)
    })
  }
  async changeCart(payload) {
      return this.fetch(`/cart/change.js`, {
          method: 'POST',
          credentials: 'same-origin',
          headers: {
            'Content-Type': 'application/json',
            'X-Requested-With': 'xmlhttprequest'
          },
          body: JSON.stringify(payload)
        }).then((response) => response.json());
   }
   async addToCart(payload) {
      let config = {
          method: 'POST',
          credentials: 'include',
          headers: {
              'Content-Type': 'application/json',
          },
          body: JSON.stringify(payload),
      }
      return this.fetch("/cart/add.js",config)
          .then((response) => response.json())
   }
   
   static setupDawnProductForm(form) {
      form.querySelector("button").addEventListener("click",event=>{
         event.preventDefault();
         event.stopPropagation();
         new CnR().addToDawnCart(form).then(response=>{
           
       });
      });
    }
    async addToDawnCart(form) {

       let cart = document.querySelector("cart-drawer");
       const formData = new FormData();
       formData.append('product-id',form.dataset.productId);
       formData.append("id",form.querySelector('[name="id"]').value)
       formData.append("quantity",1);
       try {
         formData.append("selling_plan",form.querySelector('[name="selling_plan"]').value);  
       } catch(e) {}
       
       formData.append('sections',cart.getSectionsToRender().map((section) => section.id));
       formData.append('sections_url',form.dataset.url);
       formData.append('form_type','product');
       
       return this.fetch("/cart/add",{
           method: 'POST',
           headers: {
               "Accept":"application/javascript",
               "X-Requested-With":"XMLHttpRequest"
           },
           body: formData,form
       })
           .then((response) => response.json())
           .then(json=>{
             
             
             if (json.status) {
               CnRModal.show(json.description);
             } else {
               cart.renderContents(json);
               cart.classList.remove("is-empty")
             }
             return json;
       });
    }

   /* graphql functions */
   async graphql(query,params) {
      return fetch(`/api/${this.api_version}/graphql.json`,{
          method:"POST",
          headers:{
            "content-type":"application/json",
            "X-Shopify-Storefront-Access-Token":this.config.graphql_token
            },
            body:JSON.stringify({query:query,variables:params})
          })
          .then(response=>response.json())
  }
  graphql_sync(query,params) {
      let ajax = new XMLHttpRequest();
      ajax.headers = {
          "content-type":"application/json",
          "X-Shopify-Storefront-Access-Token":this.config.graphql_token
      }
      ajax.open("POST",/api/`${this.api_version}/graphql.json`,false)
      ajax.setRequestHeader("Content-Type", "application/json");
      ajax.setRequestHeader("X-Shopify-Storefront-Access-Token", storefront_token);
      ajax.send(JSON.stringify({query:query,params:params}));
      return JSON.parse(ajax.responseText);
  }
  gid2id(gid) {
    return parseInt(gid.split("/").pop())
  }
  collapse_query(object) {
    if (object==null) {
        return object;
    }
    switch(object.constructor.name) {
    case "Array":
        return object.map(item=>this.collapse_query(item));
        break;
        case "Object":
            let ret = {};
            Object.keys(object).forEach(key=>{
                if (object[key]==null) {
                    ret[key] = null;
                    return;
                }
                
                
                if (object[key].toString().startsWith("gid")) {
                  object[key] = object[key].split("/").pop()
                }
                
                if (object[key].reference) {
                    ret[key] = this.collapse_query(object[key].reference)
                    return; 
                }
                if (object[key].references) {                        
                    let all = [];
                    object[key].references.nodes.forEach(ref=>{
                        let crv = {};
                        ref.fields.forEach(field=>{
                            crv[field.key]=this.collapse_query(field.value)
                        })
                        all.push(crv)
                    })
                    object[key] = all;
                    
                }
                
                if (object[key].amount) {
                  object[key] = parseFloat(object[key].amount)
                }
                if (object[key].isMetafield) {
                  switch(object[key].type) {
                    case "json":
                      object[key] = JSON.parse(object[key].value)
                      break;
                    default:
                      object[key] = object[key].value
                  }
                }
                if (object[key].nodes && object[key].nodes.constructor.name=="Array") {
                    ret[key] = this.collapse_query(object[key].nodes);
                } else {
                    ret[key] = this.collapse_query(object[key])
                }
            });
            return ret
            break;
        default:
            if (object) {
                return object;
            }
            
            break;
    }
}     
   css() {
      return '';
   }
   inject_css() {
      let css = this.css();
      if (css.length>0) {
          let style = document.createElement("style");
          style.id=this.constructor.name.toLowerCase();
          style.textContent = this.css();
          document.querySelector("head").appendChild(style);
      }
      
   }
}
class CnrStorefront extends CnR {
  requires() {
    return ["graphql_token"]
  }
}
/* src/cnr-pdp-info/pdp-info.js  */
class CnrPdpInfo extends CnR {
    constructor(options) {
        super(options)
        this.loadProduct().then(q=>{
            this.processQuery(q)
        })
    }
    processQuery(q) {

    }
    loadProduct() {
        return this.graphql(
          this.query(),
          {
                id: `gid://shopify/Product/${this.config.productId}`
          }
        )
    }
    query() {
        return `
            query getProductInfo($id:ID!) {
                product(id:$id) {
                    id
                    title
                    descriptionHtml
                    description
                    handle
                    url: onlineStoreUrl
                    tags
                    featuredImage {
                        url
                    }
                    featuredImage {
                        alt: altText
                        url
                    }
                    variants(first:100) {
                        nodes {
                            id
                            title
                            available: availableForSale 
                            sku
                            barcode
                            price {
                                amount
                            }
                            compareAtPrice {
                                amount
                            }
                            image {
                                alt: altText
                                url
                            }
                            option: selectedOptions {
                                name
                                value
                            }
                            ${this.additionalVariantQuery()}

                        }
                    }
                    ${this.additionalProductQuery()}
                }
            }
            `
      }
    render() {

    }
    additionalProductQuery() {}
    additionalVariantQuery() {}

}
/* s4.js  */
class S4PdpInfo extends CnrPdpInfo {
    constructor(options) {
      super(options);
      document.addEventListener("cnr:variant:changed",event=>{
        this.variantChanged(event.detail)
      })
      this.monitorForm()
      this.loadProduct()
    }
    monitorForm() {
      let id = document.querySelector('form[data-type="add-to-cart-form"]').querySelector('[name="id"]'); 
      
      switch(id.tagName) {
        case "SELECT":
          id.addEventListener("change",event=>{
            console.error("select change")
            this.variantChanged(id.options[id.selectedIndex].value)
          })
          break;
        default:
          this.variant_observer = new MutationObserver((list,observer)=>{          
            this.variantChanged(id.value)
          });
          this.variant_observer.observe(id,{attributes:true,subtree:false,childList:true});
      }   
    }
    additionalProductQuery() {
        return `
        additionalItems: metafield(namespace:"cnr",key:"additional_items") {
            type
            value
            __typename
            entry: reference {
              __typename
              ... on Metaobject {
                fields {
                  key
                  value
                    products: references(first:50) {
                      nodes {
                        ... on Product {
                          id
                          handle
                          productType
                          url: onlineStoreUrl
                          description: descriptionHtml
                          featuredImage {
                            alt: altText
                            url
                          }
                          tags
                          media(first:2) {
                            nodes {
                              image: previewImage {
                                url
                              }
                            }
                          }
                          
                          sku: metafield(namespace:"cnr",key:"parent_sku") {
                              isMetafield: __typename
                              value
                          }
                          title: metafield(namespace:"cnr",key:"title") {
                              isMetafield: __typename
                              value
                          }
                          subtitle: metafield(namespace:"cnr",key:"subtitle") {
                              isMetafield: __typename
                              value
                          }
                          variants(first: 10) {
                            edges {
                              node {
                                id
                                sku
                                title
                                price {
                                  amount
                                }
                                availableForSale
                              }
                            }
                          }
                        }
                      }
                    }  
                  }
                }
            }
        }
        productInfo: metafield(namespace:"cnr",key:"product_information_tab_v1") {
            isMetafield: __typename
            type
            value
        }
        family: metafield(namespace:"facets",key:"product_family") {
            isMetafield: __typename
            type
            value
        }
        featuresAndBenefits: metafield(namespace:"cnr",key:"features_and_benefits") {
            isMetafield: __typename
            type
            value
        }
        `
    }
    additionalVariantQuery() {
        return `
        productInfo: metafield(namespace:"cnr",key:"product_information_tab_v1") {
            isMetafield: __typename
            type
            value
        }
        `
    }
    organizeAdditional(products) {
      let parsed = {}
      products.forEach(product=>{
        let productType = product.productType;
        if (parsed[productType]) {
          parsed[productType].push(product)
        } else {
          parsed[productType] = [product]
        }
        
      })
      return parsed
    }
    processQuery(q) {
        let id = document.querySelector('form[data-type="add-to-cart-form"]').querySelector('[name="id"]'); 
        
        this.product = this.collapse_query(q).data.product
        if (this.product.additionalItems) {
          
          
          let additionalItems = {
            "required":this.organizeAdditional(this.product.additionalItems.entry.fields.find(field=>field.key=="required").products||[]),
            "compatible":this.organizeAdditional(this.product.additionalItems.entry.fields.find(field=>field.key=="compatible").products||[]),
          }
          
          this.product.additionalItems = additionalItems
          this.renderAdditionalSection("required",this.product.additionalItems.required)
          this.renderAdditionalSection("compatible",this.product.additionalItems.compatible)
        }
        if (this.product) {
          window.productInfo = this.product;
          const event = new CustomEvent("productInfoReady", { detail: this.product });
          window.dispatchEvent(event);
        }

        this.variantChanged(id.value)
    }

    generateContent(section, items) {
      const container = document.querySelector(`.${section}-container`);

      if (!container) {
          console.error(`No container found for section: ${section}`);
          return;
      }

      container.innerHTML = ""; // Clear existing content

      Object.keys(items).forEach((category) => {
          const products = items[category];
          const categoryTitle = document.createElement("h3");
          categoryTitle.textContent = category;
          container.appendChild(categoryTitle);

          const productList = document.createElement("div");
          productList.className = "product-list";

          products.forEach((product) => {
              const productCard = document.createElement("div");
              productCard.className = "product-card";

              const image = document.createElement("img");
              image.src = product.featuredImage?.url;
              image.alt = product.featuredImage?.alt || product.productType;

              const title = document.createElement("h4");
              title.textContent = product.productType;

              const price = document.createElement("span");
              price.textContent = `$${product.variants[0]?.price.amount || "N/A"}`;

              productCard.appendChild(image);
              productCard.appendChild(title);
              productCard.appendChild(price);

              productList.appendChild(productCard);
          });

          container.appendChild(productList);
      });
    }

    renderTabs(tabsData) {
      const tabsContainer = document.querySelector(".tabs-container");
      if (!tabsContainer) {
          console.error("No tabs container found.");
          return;
      }

      tabsContainer.innerHTML = ""; // Clear existing tabs

      Object.keys(tabsData).forEach((tabName) => {
          const tabButton = document.createElement("button");
          tabButton.className = "tab-button";
          tabButton.textContent = tabName;
          tabButton.addEventListener("click", () => {
              this.generateContent(tabName, tabsData[tabName]);
          });

          tabsContainer.appendChild(tabButton);
      });

      // Automatically trigger the first tab
      const firstTab = tabsContainer.querySelector(".tab-button");
      if (firstTab) {
          firstTab.click();
      }
    }

    renderAdditionalSection(section,items) {
      Object.keys(items).forEach(key=>{
        let products = items[key];
        
      })
    }
    variantChanged(variantId) {
      let selectedVariant = this.product.variants.find(variant=>variant.id==variantId);
      this.renderProductInfo(selectedVariant)
    }
    renderProductInfo(selectedVariant) {
      let html = selectedVariant.productInfo[0].map(datapoint=>`
        <div class="info-list-item">
          <span class="info-name">${datapoint.label}:</span> <span class="info-value">${datapoint.value}</span>
        </div>
      `).join("")
      let root = document.querySelector(".product-info-container .info-list");
      if (root) {
        root.innerHTML = html;
      }
    }
}
